const items = [
  "Impressão DTF têxtil alta definição",
  "Filme têxtil de alta qualidade",
  "Sem mínimo de peças",
  "Aproveitamento total do filme",
  "Resistência a lavagens",
  "Algodão, poliéster e mistos",
  "Envio para todo o Brasil",
];

export const Marquee = () => (
  <section
    aria-hidden="true"
    className="overflow-hidden border-y border-neutral-200 bg-[#f6f6f5] py-5"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {items.map((t) => (
            <span
              key={`${dup}-${t}`}
              className="display flex items-center whitespace-nowrap px-7 text-sm font-bold uppercase tracking-[0.14em] text-black sm:text-base"
            >
              {t}
              <span className="ml-7 text-[#f58244]">✳</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
